// extracted by mini-css-extract-plugin
export default {"TypeRdv":"TypeRdv_TypeRdv__Lmnyg","Couleur":"TypeRdv_Couleur__NSzZW","CouleurLocked":"TypeRdv_CouleurLocked__nUUhQ","Libelle":"TypeRdv_Libelle__OmS2i","Duree":"TypeRdv_Duree__ZCZHO"};